/**
 * Handles large display of studies
 * @param studiesWrapper Main DOM element that wraps all internal items
 */
export const caseStudyListNewControls = (studiesWrapper: HTMLElement): void => {
  const nextStudy = studiesWrapper.querySelector('#nextStudies') as unknown as HTMLElement
  const prevStudy = studiesWrapper.querySelector('#prevStudies') as unknown as HTMLElement

  const sliderWrapper = studiesWrapper.querySelector('.js-caseStudySlider_2022-sliderWrapper') as unknown as HTMLElement

  const slider = tns({
    container: sliderWrapper,
    items: 1,
    slideBy: 'page',
    loop: true,
    autoplay: false,
    autoHeight: true,
    mouseDrag: true,
    swipeAngle: false,
    nav: false,
    gutter: 0,
    prevButton: prevStudy,
    nextButton: nextStudy,
    responsive: {
      768: {
        items: 2,
        gutter: 30
      },
      3199: {
        gutter: 60
      }
    }
  })

  const sliderManualTriggers = studiesWrapper.querySelectorAll('.js-caseStudySlider_2022-manualTrigger') as unknown as HTMLElement[]

  sliderManualTriggers.forEach((single) => {
    single.addEventListener('click', () => {
      nextStudy.click()
    })
  })

  window.addEventListener('resize', () => {
    if (slider) {
      slider.updateSliderHeight()
    }
  })
}
